<script>
import { levelColor } from './severity';

export default {
    name: 'FacetsSidebar',
    props: {
        facets: { type: Object, required: true },
        activeLevels: { type: Array, default: () => [] },
        activeChannels: { type: Array, default: () => [] },
    },
    emits: ['toggle-level', 'toggle-channel', 'clear'],
    methods: {
        levelColor,
    },
};
</script>

<template>
    <div class="logs-facets">
        <div class="box box-solid" style="margin-bottom: 10px">
            <div class="box-header with-border">
                <strong>Severity</strong>
                <a
                    v-if="activeLevels.length"
                    href="#"
                    class="pull-right small"
                    @click.prevent="$emit('clear', 'levels')"
                >clear</a>
            </div>
            <div class="box-body no-padding">
                <ul class="nav nav-pills nav-stacked">
                    <li
                        v-for="(count, level) in facets.levels"
                        :key="level"
                        :class="{ active: activeLevels.includes(level) }"
                    >
                        <a href="#" @click.prevent="$emit('toggle-level', level)">
                            <span
                                class="badge-dot"
                                :style="{ background: levelColor(level) }"
                            ></span>
                            {{ level }}
                            <span class="pull-right badge">{{ count }}</span>
                        </a>
                    </li>
                    <li v-if="!Object.keys(facets.levels).length" class="text-muted" style="padding: 8px 12px">
                        No data
                    </li>
                </ul>
            </div>
        </div>

        <div class="box box-solid">
            <div class="box-header with-border">
                <strong>Channel</strong>
                <a
                    v-if="activeChannels.length"
                    href="#"
                    class="pull-right small"
                    @click.prevent="$emit('clear', 'channels')"
                >clear</a>
            </div>
            <div class="box-body no-padding">
                <ul class="nav nav-pills nav-stacked">
                    <li
                        v-for="(count, channel) in facets.channels"
                        :key="channel"
                        :class="{ active: activeChannels.includes(channel) }"
                    >
                        <a href="#" @click.prevent="$emit('toggle-channel', channel)">
                            {{ channel }}
                            <span class="pull-right badge">{{ count }}</span>
                        </a>
                    </li>
                    <li v-if="!Object.keys(facets.channels).length" class="text-muted" style="padding: 8px 12px">
                        No data
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
.badge-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
}
</style>
